import styled from 'styled-components';

export const ReceituarioContainer = styled.div`
  .react-pdf__Document {
    height: auto !important;
    width: 100%;
    background: gray !important;
  }

  .react-pdf__Page__svg {
    height: auto !important;
    width: 85% !important;
    margin: 35px 8% 0px !important;
    margin-bottom: 60px !important;
    background: white !important;
    svg {
      width: 80% !important;
      height: auto !important;
    }
  }

  .react-pdf__message.react-pdf__message--error {
    display: none;
  }
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  justify-content: center;
  padding: 32px 0 0 0;
`;

export const UnblockerButton = styled.button`
  display: flex;
  width: 100%;
  margin: 16px 0 32px 0;
  padding-top: 8px;
  padding-bottom: 8px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #f7f7fa;
  cursor: pointer;
  border: 1px dashed #8a9eb5;
  border-radius: 6px;
  user-select: none;
  width: 100%;
  height: 50px;
  max-width: 335px;
  @media (max-width: 330px) {
    width: 300px;
  }
`;

export const UnblockerButtonLabel = styled.span`
  margin-left: 10px;
  font-size: 16px;
  color: #78849e;
  opacity: 1;
  font-family: 'Rubik';
`;
export const ExamList = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const MedicineItem = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
export const MedicineList = styled.div`
  margin-top: ${(props) => (props.unlocked ? '32px' : '0')};
  display: flex;
  align-items: center;
  flex-direction: column;
`;
export const ActionArea = styled.div`
  width: 335px;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.spacing.base};
  @media (max-width: 330px) {
    width: 300px;
  }
`;

export const PdfContainer = styled.div`
  background: gray;
  display: flex;
  max-width: 100vw;
  height: auto;
  min-height: 3000px;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  padding-bottom: 200px;
  canvas {
    padding-top: 50px;
    padding-bottom: 100px;
    margin: 0 auto;
  }
`;

export const PdfNotFoundContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-top: 120px;
`;

export const NotFoundReaderPdfTitle = styled.div`
  font-size: 16px;
  color: ${(props) => props.theme.palette.primary.main};
  text-align: center;
  margin: 20px;
`;

export const NotFoundReaderPdfButton = styled.button`
  display: flex;
  flex-wrap: wrap;
  position: fixed;
  bottom: 20px;
  max-width: 100%;
  height: 50px;
  border: 1px solid ${(props) => props.theme.palette.primary.main};
  border-radius: 8px;
  width: 279px;
  text-align: center;
  font-weight: 600;
  color: ${(props) => props.theme.palette.primary.main};
  justify-content: center;
  align-content: center;
  align-self: center;
  background: ${(props) => props.theme.palette.primary.contrastText};

  a {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;
